<div class="page">
    <div class="page-body" *ngIf="response.status == 1">
        <div class="page-title" *ngIf="page.mostrar_titulo">
            <div class="container">
                <h1 class="wow slideInDown">{{page.titulo}}</h1>
                <h2 *ngIf="page.mostrar_subtitulo">{{page.subtitulo}}</h2>
            </div>    
        </div>
        <div class="page-content">
            <section class="section section-descricao wow fadeIn">
                <div class="container"> 
                    <div class="row">
                        <div class="col-md-5">
                            <img [src]="photo" alt="Liderança - Greenhouse" class="photo wow slideInLeft" data-wow-delay="0.5s" />
                        </div>
                        <div class="col-md-7">
                            <article class="descricao wow slideInRight" [innerHtml]="page.texto | safeHtml"></article> 
                            <div class="pastores">
                                <span>Pastores</span><br>
                                <strong>{{params.pastores}}</strong>
                            </div>      
                        </div>
                    </div>
                </div>    
            </section>
        </div>
    </div>
    <div class="page-body" *ngIf="response.status == 500">
        <page-error (reload)="getData()"></page-error>   
    </div>    
</div>        
<loader [hidden]="!loader" message="Carregando. Aguarde!"></loader> 